<template>
  <div class="app-container">
    <!-- <JykHeader /> -->
    <JykTable />
  </div>
</template>

<script>
// import JykHeader from './components/JykHeader'
import JykTable from './components/JykTable'
export default {
    components: {
        JykTable
    },
    props: {

    },
    data() {
        return {}
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.$bus.emit('showNavSearch', false)// 搜索去掉
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
        if (document.querySelector('.dwyc')) {
            document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'block'
        }
    },
    mounted() {
        if (document.querySelector('.dwyc')) {
            document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'none'
        }
    },
    methods: {}
}
</script>

<style scoped lang="scss">

</style>
